/**
 * Proforma status → pill tone + label (ADR-0032). Its own lifecycle, NOT
 * the invoice one: draft → finalized → converted | expired.
 */
import type { StatusTone } from "@flint/ui";

export type ProformaStatus = "draft" | "finalized" | "converted" | "expired";

export function proformaStatusTone(status: ProformaStatus): StatusTone {
  switch (status) {
    case "converted":
      return "ok";
    case "finalized":
      return "sky";
    case "expired":
      return "bad";
    case "draft":
    default:
      return "muted";
  }
}

export function proformaStatusLabel(status: ProformaStatus): string {
  switch (status) {
    case "converted":
      return "Converted";
    case "finalized":
      return "Finalized";
    case "expired":
      return "Expired";
    case "draft":
    default:
      return "Draft";
  }
}
